export default __webpack_public_path__ + "static/media/consultation.37a0dcc0.png";